<template>
  <div :class="{'p-dynamic-form': depth === 0}">
    <h1 v-if="formCaption">
      {{ formCaption }}
    </h1>
    <template v-if="depth === 0">
    <p-row v-if="contactFieldsVisibility.isContactTypeSelectionVisible" align-end class="contactTypeSelection">
        <p-col shrink v-for="(item) in contactFormTypeItems" :key="item.id">
        <p-radio-field v-model="formPayload.contactFormType" :true-value="item.id" :label="item.caption" ></p-radio-field>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isSalutationVisible" align-end class="salutation">
        <p-col xs12>
          <p-select
            v-model="formPayload.contact.salutation"
            :items="salutationItems"
            :required="contactFieldsRequirement.isSalutationRequired"
            :label="$t('core.address.salutation')"
          ></p-select>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isFirstNameVisible">
        <p-col xs12>
          <p-text-field
            v-model="formPayload.contact.firstName"
            :required="contactFieldsRequirement.isFirstNameRequired"
            name="fname"
            autocomplete="cc-given-name"
            :label="$t('core.address.firstName')"
          ></p-text-field>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isLastNameVisible">
        <p-col xs12>
          <p-text-field
            v-model="formPayload.contact.lastName"
            :required="contactFieldsRequirement.isLastNameRequired"
            name="lname"
            autocomplete="cc-family-name"
            :label="$t('core.address.lastName')"
          ></p-text-field>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isCompanyNameVisible">
        <p-col xs12>
          <p-text-field
            v-model="formPayload.contact.companyName"
            :required="contactFieldsRequirement.isCompanyNameRequired"
            name="company"
            autocomplete="organization"
            :label="$t('core.address.company')"
          ></p-text-field>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isStreetVisible || contactFieldsVisibility.isHouseNumberVisible">
        <p-col v-if="contactFieldsVisibility.isStreetVisible" :xs9="contactFieldsVisibility.isHouseNumberVisible">
          <p-text-field v-model="formPayload.contact.street" :required="contactFieldsRequirement.isStreetRequired" autocomplete="address-line1" :label="$t('core.address.street')"></p-text-field>
        </p-col>
        <p-col v-if="contactFieldsVisibility.isHouseNumberVisible" :xs3="contactFieldsVisibility.isStreetVisible">
          <p-text-field v-model="formPayload.contact.houseNumber" :required="contactFieldsRequirement.isHouseNumberRequired" autocomplete="house-number" :label="$t('core.address.houseNumber')"></p-text-field>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isAddressLine1Visible">
        <p-col xs12>
          <p-text-field v-model="formPayload.contact.addressLine1" :required="contactFieldsRequirement.isAddressLine1Required" :label="$t('core.address.addressLine1')" autocomplete="address-line2"></p-text-field>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isPoBoxVisible">
        <p-col xs12>
          <p-text-field v-model="formPayload.contact.poBox" :required="contactFieldsRequirement.isPoBoxRequired" autocomplete="po-box" :label="$t('core.address.poBox')"></p-text-field>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isPostalCodeVisible || contactFieldsVisibility.isCityVisible">
        <p-col v-if="contactFieldsVisibility.isPostalCodeVisible" :xs3="contactFieldsVisibility.isCityVisible">
          <p-text-field v-model="formPayload.contact.postalCode" :required="contactFieldsRequirement.isPostalCodeRequired" autocomplete="postal-code" :label="$t('core.address.postalCode')"></p-text-field>
        </p-col>
        <p-col v-if="contactFieldsVisibility.isCityVisible" :xs9="contactFieldsVisibility.isPostalCodeVisible">
          <p-text-field v-model="formPayload.contact.city" :required="contactFieldsRequirement.isCityRequired" autocomplete="address-level2" :label="$t('core.address.city')"></p-text-field>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isCountryVisible">
        <p-col xs12>
          <p-select
            v-model="formPayload.contact.countryIso2"
            :required="contactFieldsRequirement.isCountryRequired"
            :items="countryLookupItems"
            :label="$t('core.address.country')"
          ></p-select>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isEmailVisible">
        <p-col xs12>
          <p-text-field
            v-model="formPayload.contact.eMail"
            :required="contactFieldsRequirement.isEmailRequired"
            type="email"
            name="email"
            autocomplete="email"
            :label="$t('core.address.email')"
          ></p-text-field>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isPhoneNumberVisible">
        <p-col xs12>
          <p-phone-field
            v-model="formPayload.contact.phoneNumber"
            :required="contactFieldsRequirement.isPhoneNumberRequired"
            autocomplete="tel"
            name="phoneNumber"
            :label="$t('core.address.phoneNumber')"
          ></p-phone-field>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isMobilePhoneNumberVisible">
        <p-col xs12>
          <p-phone-field
            v-model="formPayload.contact.mobilePhoneNumber"
            :required="contactFieldsRequirement.isMobilePhoneNumberRequired"
            autocomplete="mobile tel"
            name="mobilePhoneNumber"
            :label="$t('core.address.mobilePhoneNumber')"
          ></p-phone-field>
        </p-col>
      </p-row>
      <p-row v-if="contactFieldsVisibility.isDateOfBirthVisible">
        <p-col xs12>
          <p-date-field
            v-model="formPayload.contact.dateOfBirth"
            :required="contactFieldsRequirement.isDateOfBirthRequired"
            name="dateOfBirth"
            :label="$t('core.address.birthDate')"
          >
          </p-date-field>
        </p-col>
      </p-row>
    </template>
    <div :class="classList">
      <template v-for="(field, index) in fieldDefinitions">
        <template v-if="field.inputType === fieldTypeIds.fileSingleInput || field.inputType === fieldTypeIds.fileMultipleInput">
          <p-file-drop
            :key="field.id"
            :max-file-size="30"
            :label="field.caption"
            :max="field.max"
            :min="field.min"
            :loading="isLoading[field.id]"
            :errors="errors[field.id]"
            :single="field.inputType === fieldTypeIds.fileSingleInput"
            :accept="fileInputAccept"
            @add-file="onFileAdded(field, $event, index)"
            @remove-file="onFileRemoved(field, $event, index)"
          ></p-file-drop>
        </template>
        <template v-else>
          <component
            :is="componentMap[field.id]"
            :key="field.id"
            v-model="userValues[field.id]"
            :required="field.isRequired"
            :clearable="field.isClearable"
            :messages="field.description"
            :min="field.min"
            :max="field.max"
            :placeholder="field.placeholder"
            :class="getFieldClass(field)"
            :items="field.picklistItems"
            :label="field.caption"
            :errors="errorMessages[field.id]"
            @input="onUserValueInput"
            @blur="validateComponent(field)"
            @clear="validateComponent(field)"
          >
            <template v-if="field.inputType === fieldTypeIds.heading">
              {{ field.caption }}
            </template>
            <template v-if="field.inputType === fieldTypeIds.paragraph">
              <span v-html="markdownToHtml(field.caption)"></span>
            </template>
            <p-dynamic-form
              v-else-if="field.inputType === fieldTypeIds.group"
              :value="value"
              :depth="depth + 1"
              :groups-are-accordions="groupsAreAccordions"
              :group-display-overrides="groupDisplayOverrides"
              :inside-accordion="isAccordion(field)"
              :form-definition="field.items"
              :target-blank="targetBlank"
              @input="onGroupInput"
              @update:summary="onSummaryInput"
            ></p-dynamic-form>
          </component>
        </template>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue, { PropType } from 'vue';
  import { marked } from 'marked';
  import PDateField from '../p-date-field/p-date-field.vue';
  import PTimeField from '../p-time-field/p-time-field.vue';
  import PDateTimeField from '../p-date-time-field/p-date-time-field.vue';
  import PFileDrop from '../p-file-drop/p-file-drop.vue';
  import PSelect from '../p-select/p-select.vue';
  import PTextarea from '../p-textarea/p-textarea.vue';
  import PTextField from '../p-text-field/p-text-field.vue';
  import PCheckbox from '../p-checkbox/p-checkbox.vue';
  import PCheckboxGroup from '../p-checkbox-group/p-checkbox-group.vue';
  import PPhoneField from '../p-phone-field/p-phone-field.vue';
  import PFieldset from '../p-fieldset/p-fieldset.vue';
  import PAccordion from '../p-accordion/p-accordion.vue';
  import _ from '../../utils';
  import { IJSONSchema } from '../../plugins/validation/IJSONSchema';
  import { RequestSummaryItemResourceViewModel } from '../../services/v1/viewModel/resource/RequestSummaryResourceViewModel';
  import DynamicFormPayloadResourceViewModel from '../../services/v1/viewModel/resource/DynamicFormPayloadResourceViewModel';
  import DynamicFormDefinitionResourceViewModel from '../../services/v1/viewModel/resource/DynamicFormDefinitionResourceViewModel';
  import DynamicFormFieldDefinitionResourceViewModel from '../../services/v1/viewModel/resource/DynamicFormFieldDefinitionResourceViewModel';
  import DynamicFormFieldInputTypeResourceViewModel from '../../services/v1/viewModel/resource/DynamicFormFieldInputTypeResourceViewModel';
  import DynamicFormFieldPayloadResourceViewModel from '../../services/v1/viewModel/resource/DynamicFormFieldPayloadResourceViewModel';
  import DynamicFormUploadDocumentRequestViewModel from '../../services/v1/viewModel/request/DynamicForm/DynamicFormUploadDocumentRequestViewModel';
  import queryBuilder from '../../plugins/validation/queryBuilder';
  import validationPatterns from '../../plugins/validation/validationPatterns';
  import IPDynamicFormGroupDisplay from './IPDynamicFormGroupDisplay';

  interface ContactFieldsVisibility {
    isSalutationVisible: boolean,
    isFirstNameVisible: boolean,
    isLastNameVisible: boolean,
    isCompanyNameVisible: boolean,
    isStreetVisible: boolean,
    isHouseNumberVisible: boolean,
    isAddressLine1Visible: boolean,
    isPoBoxVisible: boolean,
    isPostalCodeVisible: boolean,
    isCityVisible: boolean,
    isCountryVisible: boolean,
    isEmailVisible: boolean,
    isPhoneNumberVisible: boolean,
    isMobilePhoneNumberVisible: boolean,
    isDateOfBirthVisible: boolean,
    isContactTypeSelectionVisible: boolean
  }

  interface contactFieldsRequirement {
    isSalutationRequired: boolean,
    isFirstNameRequired: boolean,
    isLastNameRequired: boolean,
    isCompanyNameRequired: boolean,
    isStreetRequired: boolean,
    isHouseNumberRequired: boolean,
    isAddressLine1Required: boolean,
    isPoBoxRequired: boolean,
    isPostalCodeRequired: boolean,
    isCityRequired: boolean,
    isCountryRequired: boolean,
    isEmailRequired: boolean,
    isPhoneNumberRequired: boolean,
    isMobilePhoneNumberRequired: boolean,
    isDateOfBirthRequired: boolean,
  }

  export default Vue.extend({
    name: 'PDynamicForm',
    props: {
      noContactFields: { type: Boolean, default: false },
      noAddressFields: { type: Boolean, default: false },
      value: { type: Object as PropType<(DynamicFormPayloadResourceViewModel & Record<string, any>) | undefined>, default: undefined },
      formDefinition: { type: [Object, Array] as PropType<DynamicFormDefinitionResourceViewModel | DynamicFormFieldDefinitionResourceViewModel[]>, default: undefined },
      depth: { type: Number, default: 0 },
      groupsAreAccordions: { type: Boolean, default: false },
      groupDisplayOverrides: { type: Array as PropType<IPDynamicFormGroupDisplay[]>, default: undefined },
      insideAccordion: { type: Boolean, default: false },
      jsonSchema: { type: Object, default: undefined },
      noValidation: { type: Boolean, default: false },
      contactId: { type: [String, Number] as PropType<string | number | undefined>, default: undefined },
      fileInputAccept: { type: Array, default: () => ['.png', '.jpg', '.jpeg', '.bmp', '.gif', '.docx', '.pdf', '.xlsx', '.zip'] },
      targetBlank: { type: Boolean, default: true },
    },
    data: () => ({
      innerContactId: undefined as string | number | undefined,
      countryLookupItems: [
        { caption: Vue.$t('core.country.switzerland'), id: 'CH' },
        { caption: Vue.$t('core.country.germany'), id: 'DE' },
        { caption: Vue.$t('core.country.austria'), id: 'AT' },
        { caption: Vue.$t('core.country.italy'), id: 'IT' },
        { caption: Vue.$t('core.country.france'), id: 'FR' },
      ],
      salutationItems: [{ caption: Vue.$t('core.address.salutationEnum1'), id: 1 },
                        { caption: Vue.$t('core.address.salutationEnum2'), id: 2 },
                        { caption: Vue.$t('core.address.salutationEnum3'), id: 3 }],
      isLoading: {} as Record<string, boolean>,
      contactFormTypeItems: [
        { caption: Vue.$t('core.address.contactFormTypeEnum1'), id: 1 },
        { caption: Vue.$t('core.address.contactFormTypeEnum2'), id: 2 }],
      errors: {} as Record<string, string | undefined>,
      /**
       * Maps file-upload component to a dictionary of documentId, File
       * Each component needs a separate dict to make sure there are no duplicates etc.
       */
      documentIdToFileMap: {} as Record<number, Record<string, File>>,
      userValues: {} as Record<string, any>,
      errorMessages: {} as Record<string, string>,
      childSummary: [] as RequestSummaryItemResourceViewModel[],
      formPayload: new DynamicFormPayloadResourceViewModel().fromDTO({ definitionId: undefined as any, fields: [] }),
      /** Maps the field id to a component which can be rendered */
      componentMap: {} as Record<string, any>,
      fieldDefinitions: [] as DynamicFormFieldDefinitionResourceViewModel[],
    }),
    computed: {
      settings() {
        return _.isArray(this.formDefinition) ? undefined : this.formDefinition.settings;
      },
      contactFieldsVisibility(): ContactFieldsVisibility {
        const s = this.settings;
        const hasContactForm = !this.noContactFields && !this._.isSet(this.innerContactId);
        const hasAddressForm = !this.noAddressFields && !this._.isSet(this.innerContactId) && !(s?.hideAddress ?? false);
        const isPerson = this.formPayload.contactFormType === 1;
        return {
          isSalutationVisible: hasContactForm,
          isFirstNameVisible: hasContactForm,
          isLastNameVisible: hasContactForm,
          isCompanyNameVisible: hasContactForm && !(s?.hideCompanyName ?? false) && !isPerson,
          isStreetVisible: hasAddressForm,
          isHouseNumberVisible: hasAddressForm && !(s?.hideHouseNumber ?? false),
          isAddressLine1Visible: hasAddressForm && !(s?.hideAddressLine1 ?? false),
          isPoBoxVisible: hasAddressForm && !(s?.hidePOBox ?? false),
          isPostalCodeVisible: hasAddressForm,
          isCityVisible: hasAddressForm,
          isCountryVisible: hasAddressForm && !(s?.hideCountry ?? false),
          isEmailVisible: hasContactForm,
          isPhoneNumberVisible: hasContactForm && !(s?.hidePhoneNumber ?? false),
          isMobilePhoneNumberVisible: hasContactForm && !(s?.hideMobilePhoneNumber ?? false),
          isDateOfBirthVisible: hasContactForm && !(s?.hideDateOfBirth ?? false),
          isContactTypeSelectionVisible: s?.dynamicFormContactFormType === 3
        };
      },
      contactFieldsRequirement(): contactFieldsRequirement {
        const s = this.settings;
        const v = this.contactFieldsVisibility;
        const isPerson = this.formPayload.contactFormType === 1;
        const isCompany = this.formPayload.contactFormType === 2;

        return {
          isSalutationRequired: v.isSalutationVisible && isPerson,
          isFirstNameRequired: v.isFirstNameVisible&& isPerson,
          isLastNameRequired: v.isLastNameVisible&& isPerson,
          isCompanyNameRequired: v.isCompanyNameVisible&& isCompany,
          isStreetRequired: v.isStreetVisible && (s?.mandatoryAddress ?? true),
          isHouseNumberRequired: false,
          isAddressLine1Required: false,
          isPoBoxRequired: false,
          isPostalCodeRequired: v.isPostalCodeVisible && (s?.mandatoryAddress ?? true),
          isCityRequired: v.isCityVisible && (s?.mandatoryAddress ?? true),
          isCountryRequired: v.isCountryVisible && (s?.mandatoryAddress ?? true),
          isEmailRequired: v.isEmailVisible && (s?.mandatoryEmail ?? true),
          isPhoneNumberRequired: false,
          isMobilePhoneNumberRequired: false,
          isDateOfBirthRequired: false,
        };
      },
      formCaption(): string | undefined {
        if (!_.isArray(this.formDefinition)) {
          return this.formDefinition?.caption ?? undefined;
        }
        return undefined;
      },
      fieldTypeIds() {
        // Because enums can not be used in the vue template and we don't want magic numbers
        // we get it like this
        return {
          group: DynamicFormFieldInputTypeResourceViewModel.Group,
          fileSingleInput: DynamicFormFieldInputTypeResourceViewModel.FileSingleInput,
          fileMultipleInput: DynamicFormFieldInputTypeResourceViewModel.FileMultipleInput,
          paragraph: DynamicFormFieldInputTypeResourceViewModel.Paragraph,
          heading: DynamicFormFieldInputTypeResourceViewModel.Heading,
        };
      },
      classList(): Record<string, boolean> {
        return {
          'p-dynamic-form-fields': this.depth === 0,
          'p-dynamic-form-fields-group': this.depth > 0,
          [`ml-${Math.min(this.depth * 2, 6)}`]: this.depth > 0 && this.insideAccordion,
          'my-2': true,
        };
      },
    },
    watch: {
      formDefinition: {
        immediate: true,
        deep: true,
        handler(newValue, oldValue) {
          const formDefinitionId = this._.isArray(this.formDefinition) ? undefined : this.formDefinition.id;
          const userLanguage = this.$translation.get() ?? this.$config.values['language-default'];
          this.formPayload = new DynamicFormPayloadResourceViewModel().fromDTO({
            fields: [],
            contact: { countryIso2: 'CH' },
            definitionId: formDefinitionId,
            languageIso2: userLanguage,
            contactId: this.innerContactId,
          } as any);
          this.formPayload.contactFormType = (this.settings?.dynamicFormContactFormType??0) == 3?1:(this.settings?.dynamicFormContactFormType??0)
          this.populateFieldDefinitions();
          this.initUserValues(!!oldValue, this.depth === 0);
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.updateFormPayloadFromUserValues();
              this.$emit('input', this.formPayload);
            });
          });
          this.componentMap = this.buildComponentMap(this.fieldDefinitions);
          this.emitComputed();
        },
      },
      value: {
        immediate: true,
        handler() {
          this.updateUserValuesFromValue();
          this.$nextTick(() => {
            if (this._.isNil(this.value)) {
              return;
            }
            this.updateFormPayloadFromUserValues();
            this.innerContactId = this.value.contactId ?? this.innerContactId;
            Object.keys(this.value).forEach((propName) => {
              const value = this.value![propName];
              if (!this._.isObject(value)) {
                this.$set(this.formPayload, propName, value ?? (this.formPayload as any)[propName]);
              }
            });
            if (this.formPayload?.contact && this.value?.contact) {
              Object.keys(this.value.contact).forEach((propName) => {
                (this.formPayload.contact as any)[propName] = (this.value!.contact as any)[propName] ?? (this.formPayload.contact as any)[propName];
              });
            }
            this.emitComputed();
          });
        },
      },
      contactId: {
        immediate: true,
        handler() {
          this.innerContactId = this.contactId?.toString() ?? undefined;
          this.formPayload.contactId = this.innerContactId;
        },
      },
      groupsAreAccordions() {
        this.componentMap = this.buildComponentMap(this.fieldDefinitions);
      },
      groupDisplayOverrides() {
        this.componentMap = this.buildComponentMap(this.fieldDefinitions);
      },
    },
    methods: {
      initUserValues(overrideCurrentValues: boolean, deep: boolean) {
        const computedFieldDefinitions = _.isArray(this.formDefinition) ? this.formDefinition : this.formDefinition?.fields ?? [];
        this.initUserValuesRecursive(overrideCurrentValues, deep, computedFieldDefinitions);
      },
      initUserValuesRecursive(overrideCurrentValues: boolean, deep: boolean, fieldDefinitions: DynamicFormFieldDefinitionResourceViewModel[]) {
        fieldDefinitions.forEach((fieldDef) => {
          const newValue = overrideCurrentValues ? this.getDefaultValue(fieldDef) : this.userValues[fieldDef.id] ?? this.getDefaultValue(fieldDef);
          this.$set(this.userValues, fieldDef.id, newValue);
          if (deep) {
            this.initUserValuesRecursive(overrideCurrentValues, true, fieldDef.items);
          }
        });
      },
      updateFormPayloadFromUserValues() {
        this.formPayload.fields = this.formPayload.fields ?? [];
        Object.keys(this.userValues).forEach((userValueId) => {
          const userValue = this.userValues[userValueId];
          let userValues = _.isArray(userValue) ? userValue : [userValue];
          if (!_.isSet(userValue)) {
            userValues = [];
          }
          userValues = userValues.map((value: any) => value.toString());

          const fieldPayload = this.formPayload.fields.find((field) => field.id === userValueId);
          if (fieldPayload) {
            fieldPayload.values = userValues;
          } else {
            this.formPayload.fields.push(new DynamicFormFieldPayloadResourceViewModel().fromModel({
              id: userValueId,
              values: userValues,
            }));
          }
        });
      },
      onUserValueInput() {
        this.updateFormPayloadFromUserValues();
        this.$emit('input', this.formPayload);
        this.emitComputed();
      },
      updateUserValuesFromValue() {
        const fields = (this.value?.fields ?? []) as DynamicFormFieldPayloadResourceViewModel[];
        Object.keys(this.userValues).forEach((id: any) => {
          const field = fields.find((f) => f.id === id);

          if (!field) {
            // break;
            return;
          }

          const [userValue] = field.values;
          const fieldDefinition = this.fieldDefinitions.find((fieldDef) => fieldDef.id === field.id);
          const isMultiInput = (fieldDefinition?.isMultiInput ?? false);
          this.$set(this.userValues, field.id, isMultiInput ? field.values : userValue);
        });
      },
      async uploadFileAsDocument(file: File) {
        const req = new DynamicFormUploadDocumentRequestViewModel().fromModel({
          uploadFile: file,
        });
        const documentId = await this.$service.api.core.dynamicForm.dynamicFormUploadDocument(req);
        return documentId;
      },
      async onFileAdded(field: DynamicFormFieldDefinitionResourceViewModel, fileOrFiles: File | File[], index: number) {
        this.$set(this.isLoading, field.id, true);
        try {
          this.$set(this.errors, field.id, undefined);
          fileOrFiles = this._.isSet(fileOrFiles) ? fileOrFiles : [];
          const files = this._.isArray(fileOrFiles) ? fileOrFiles : [fileOrFiles];
          const allPromises = [] as Promise<string | undefined>[];
          this.documentIdToFileMap[index] = this.documentIdToFileMap[index] ?? {};
          const filesInUse = Object.values(this.documentIdToFileMap[index]);
          files.forEach((file: File) => {
            if (!filesInUse.includes(file)) {
              allPromises.push(this.uploadFileAsDocument(file));
            } else {
              // Puff the array so it matches the file array by index
              allPromises.push(Promise.resolve(undefined));
            }
          });
          const documentIds = await Promise.all(allPromises);

          documentIds.forEach((documentId, i) => {
            if (this._.isSet(documentId)) {
              // The file array will match the documentId array
              this.documentIdToFileMap[index][documentId] = files[i];
            }
          });
          this.userValues[field.id] = Object.keys(this.documentIdToFileMap[index]);
          this.onUserValueInput();
        } catch (error: any) {
          this.$set(this.errors, field.id, error?.message ?? error);
        }
        this.$set(this.isLoading, field.id, false);
      },
      onFileRemoved(field: DynamicFormFieldDefinitionResourceViewModel, fileOrFiles: File | File[], index: number) {
        this.$set(this.errors, field.id, undefined);
        fileOrFiles = this._.isSet(fileOrFiles) ? fileOrFiles : [];
        const files = this._.isArray(fileOrFiles) ? fileOrFiles : [fileOrFiles];
        const documentIdsInUse = Object.keys(this.documentIdToFileMap[index]);
        documentIdsInUse.forEach((docId) => {
          const fileInUse = this.documentIdToFileMap[index][docId];
          if (files.includes(fileInUse)) {
            delete this.documentIdToFileMap[index][docId];
          }
        });
        this.userValues[field.id] = Object.keys(this.documentIdToFileMap[index]);
        this.onUserValueInput();
      },
      populateFieldDefinitions() {
        let computedFieldDefinitions: DynamicFormFieldDefinitionResourceViewModel[] = [];
        if (_.isArray(this.formDefinition)) {
          computedFieldDefinitions = this.formDefinition;
        } else if (_.isSet(this.formDefinition)) {
          computedFieldDefinitions = this.formDefinition.fields ?? [];
        } else {
          computedFieldDefinitions = [];
        }
        // Deep clone so the definitions prop is not mutated (causes a watcher loop)
        const sortedFieldDefs = _.deepClone(computedFieldDefinitions);
        sortedFieldDefs.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
        sortedFieldDefs.forEach((fieldDef) => {
          fieldDef.picklistItems = fieldDef.picklistItems ?? [];
          fieldDef.picklistItems = fieldDef.picklistItems.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
        });
        this.fieldDefinitions = computedFieldDefinitions;
      },
      validateComponent(formField: DynamicFormFieldDefinitionResourceViewModel) {
        this.$nextTick(() => {
          const userValue = this.userValues[formField.id];
          let message;
          if (!userValue && formField.isRequired) {
            message = this.$t('core.validation.required');
          }
          if (userValue) {
            switch (formField.inputType) {
            case DynamicFormFieldInputTypeResourceViewModel.NumberInput:
              const regEx = new RegExp(validationPatterns.numberWithNDecimalPlaces(formField.decimalPlaces ?? 0));
              if (!regEx.test(userValue)) {
                message = formField.decimalPlaces != null && formField.decimalPlaces > 0
                  ? this.$t('core.validation.requiredDecimalPlaces', formField.decimalPlaces)
                  : this.$t('core.validation.mustBeInteger');
              }
              break;
            case DynamicFormFieldInputTypeResourceViewModel.TextInputPhone:
              if (!this.$format.phoneValid(userValue)) {
                message = this.$t('core.phoneNumber.invalid');
              }
              break;
            default:
              break;
            }
          }
          this.$set(this.errorMessages, formField.id, message);
        });
      },
      createJsonSchema(definition: DynamicFormFieldDefinitionResourceViewModel[]): IJSONSchema {
        let allOfs = [
          // for each field -> "contains: {...}"
        ] as IJSONSchema[];
        definition.forEach((field) => {
          if (field.inputType === DynamicFormFieldInputTypeResourceViewModel.Group) {
            const nestedSchema = this.createJsonSchema(field.items ?? []);
            allOfs = allOfs.concat((nestedSchema as any)?.properties?.fields?.allOf ?? []);
          } else {
            if (field.isRequired) {
              allOfs.push({
                contains: {
                  title: field.caption ?? undefined,
                  description: this.$t('core.validation.required'),
                  properties: {
                    id: { enum: [field.id] },
                    values: {
                      contains: field.inputType === DynamicFormFieldInputTypeResourceViewModel.DecisionInput ? { enum: ['true'] } : undefined,
                      type: 'array',
                      minItems: 1,
                    },
                  },
                },
              });
            }
            switch (field.inputType) {
            case DynamicFormFieldInputTypeResourceViewModel.NumberInput:
              allOfs.push({
                contains: {
                  title: field.caption ?? undefined,
                  description: field.decimalPlaces != null && field.decimalPlaces > 0
                    ? this.$t('core.validation.requiredDecimalPlaces', field.decimalPlaces)
                    : this.$t('core.validation.mustBeInteger'),
                  properties: {
                    id: { enum: [field.id] },
                    values: {
                      type: 'array',
                      items: {
                        pattern: validationPatterns.numberWithNDecimalPlaces(field.decimalPlaces ?? 0),
                      },
                    },
                  },
                },
              });
              break;
            case DynamicFormFieldInputTypeResourceViewModel.TextInputPhone:
              allOfs.push({
                contains: {
                  title: field.caption ?? undefined,
                  description: this.$t('core.phoneNumber.invalid'),
                  properties: {
                    id: { enum: [field.id] },
                    values: {
                      type: 'array',
                      items: {
                        pattern: validationPatterns.phone,
                      },
                    },
                  },
                },
              });
              break;
            default:
              break;
            }
          }
        });

        const r = this.contactFieldsRequirement;
        const contactFields = {
          salutation: { type: 'number', required: r.isSalutationRequired },
          firstName: { tpye: 'string', required: r.isFirstNameRequired },
          lastName: { tpye: 'string', required: r.isLastNameRequired },
          companyName: { tpye: 'string', required: r.isCompanyNameRequired },
          street: { tpye: 'string', required: r.isStreetRequired },
          houseNumber: { tpye: 'string', required: r.isHouseNumberRequired },
          addressLine1: { tpye: 'string', required: r.isAddressLine1Required },
          poBox: { tpye: 'string', required: r.isPoBoxRequired },
          postalCode: { tpye: 'string', required: r.isPostalCodeRequired },
          city: { tpye: 'string', required: r.isCityRequired },
          countryIso2: { tpye: 'string', required: r.isCountryRequired },
          eMail: { tpye: 'string', required: r.isEmailRequired, pattern: validationPatterns.email },
          phoneNumber: { tpye: 'string', required: r.isPhoneNumberRequired, pattern: validationPatterns.phone },
          mobilePhoneNumber: { tpye: 'string', required: r.isMobilePhoneNumberRequired, pattern: validationPatterns.phone },
          dateOfBirth: { tpye: 'date', required: r.isDateOfBirthRequired },
        };

        const contactSchema = {
          contact: {
            ...queryBuilder.properties(contactFields as any),
          },
        };

        const schema = {
          type: 'object',
          properties: {
            ...contactSchema,
            fields: {
              type: 'array',
              allOf: allOfs,
            },
          },
        } as IJSONSchema;

        return schema;
      },
      getDisplayValue(definition: DynamicFormFieldDefinitionResourceViewModel) {
        const userValue = this.userValues[definition.id] as string[] | string;
        if (_.isNil(userValue)) {
          return undefined;
        }
        let displayValue = userValue.toString();
        if (!_.isEmpty(definition.picklistItems)) {
          const userValues = _.isArray(userValue) ? userValue : [userValue];
          const displayValues = [] as string[];
          userValues.forEach((val) => {
            const chosenPickItem = definition.picklistItems?.find((pickItem) => pickItem.id === val);
            if (_.isSet(chosenPickItem)) {
              displayValues.push(chosenPickItem.caption!);
            }
          });
          displayValue = displayValues.join(', ');
        }
        return displayValue;
      },
      createSummary(definition: DynamicFormFieldDefinitionResourceViewModel[]) {
        let summaryItems = [] as RequestSummaryItemResourceViewModel[];
        const v = this.contactFieldsVisibility;

        if (v.isSalutationVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.salutation'),
            displayValue: this._.isSet(this.formPayload.contact.salutation) ? this.$t(`core.address.salutationEnum${this.formPayload.contact.salutation}`) : undefined,
          }));
        }
        if (v.isFirstNameVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.firstName'),
            displayValue: this.formPayload.contact.firstName,
          }));
        }
        if (v.isLastNameVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.lastName'),
            displayValue: this.formPayload.contact.lastName,
          }));
        }
        if (v.isCompanyNameVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.company'),
            displayValue: this.formPayload.contact.companyName,
          }));
        }
        if (v.isStreetVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.street'),
            displayValue: this.formPayload.contact.street,
          }));
        }
        if (v.isHouseNumberVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.houseNumber'),
            displayValue: this.formPayload.contact.houseNumber,
          }));
        }
        if (v.isAddressLine1Visible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.addressLine1'),
            displayValue: this.formPayload.contact.addressLine1,
          }));
        }
        if (v.isPoBoxVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.poBox'),
            displayValue: this.formPayload.contact.poBox,
          }));
        }
        if (v.isPostalCodeVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.postalCode'),
            displayValue: this.formPayload.contact.postalCode,
          }));
        }
        if (v.isCityVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.city'),
            displayValue: this.formPayload.contact.city,
          }));
        }
        if (v.isCountryVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.country'),
            displayValue: this.countryLookupItems.find((country) => country.id === this.formPayload.contact.countryIso2)?.caption ?? '-',
          }));
        }
        if (v.isDateOfBirthVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.dateOfBirth'),
            displayValue: this.formPayload.contact.dateOfBirth,
          }));
        }
        if (v.isEmailVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.email'),
            displayValue: this.formPayload.contact.eMail,
          }));
        }
        if (v.isPhoneNumberVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.phoneNumber'),
            displayValue: this.formPayload.contact.phoneNumber,
          }));
        }
        if (v.isMobilePhoneNumberVisible) {
          summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
            label: this.$t('core.address.mobilePhoneNumber'),
            displayValue: this.formPayload.contact.mobilePhoneNumber,
          }));
        }

        definition.forEach((fieldDefinition) => {
          if (fieldDefinition.inputType !== DynamicFormFieldInputTypeResourceViewModel.Group) {
            const displayValue = this.getDisplayValue(fieldDefinition);
            summaryItems.push(new RequestSummaryItemResourceViewModel().fromDTO({
              label: fieldDefinition.caption,
              displayValue,
            }));
          } else {
            summaryItems = [...summaryItems as any, this.createSummary(fieldDefinition.items)];
          }
        });
        summaryItems = [...summaryItems, ...this.childSummary];
        return summaryItems.filter((item) => _.isSet(item.displayValue));
      },
      emitComputed() {
        const schema = this.createJsonSchema(this.fieldDefinitions);
        this.$emit('update:json-schema', schema);
        this.$emit('update:jsonSchema', schema);
        const summary = this.createSummary(this.fieldDefinitions);
        this.$emit('update:summary', summary);
      },
      onSummaryInput(summary: RequestSummaryItemResourceViewModel[]) {
        summary.forEach((e) => {
          const entry = this.childSummary.find((i) => i.label === e.label);
          if (entry) {
            entry.displayValue = e.displayValue;
          } else {
            this.childSummary.push(e);
          }
        });
      },
      onGroupInput(groupPayload: DynamicFormPayloadResourceViewModel) {
        groupPayload.fields.forEach((groupField) => {
          const isMultiInput = this.fieldDefinitions.find((f) => f.id === groupField.id)?.isMultiInput ?? false;
          const userValue = isMultiInput ? groupField.values : groupField.values[0];
          this.$set(this.userValues, groupField.id, userValue);
          const foundField = this.formPayload.fields.find((field) => field.id === groupField.id);
          if (foundField) {
            foundField.values = groupField.values;
          } else {
            this.formPayload.fields.push(groupField);
          }
        });
        this.$emit('input', this.formPayload);
        this.emitComputed();
      },
      mapToComponent(fieldDef: DynamicFormFieldDefinitionResourceViewModel) {
        switch (fieldDef.inputType) {
        case DynamicFormFieldInputTypeResourceViewModel.DateInput:
          return PDateField;
        case DynamicFormFieldInputTypeResourceViewModel.DateTimeInput:
          return PDateTimeField;
        case DynamicFormFieldInputTypeResourceViewModel.DecisionInput:
          return PCheckbox;
        case DynamicFormFieldInputTypeResourceViewModel.FileSingleInput:
          return PFileDrop;
        case DynamicFormFieldInputTypeResourceViewModel.FileMultipleInput:
          return PFileDrop;
        case DynamicFormFieldInputTypeResourceViewModel.SelectSingleInput:
          return PSelect;
        case DynamicFormFieldInputTypeResourceViewModel.SelectMultipleInput:
          return PCheckboxGroup;
        case DynamicFormFieldInputTypeResourceViewModel.TextInputEmail:
          return PTextField;
        case DynamicFormFieldInputTypeResourceViewModel.TextInputMultiLine:
          return PTextarea;
        case DynamicFormFieldInputTypeResourceViewModel.TextInputPhone:
          return PPhoneField;
        case DynamicFormFieldInputTypeResourceViewModel.NumberInput:
          return PTextField;
        case DynamicFormFieldInputTypeResourceViewModel.TextInputSingleLine:
          return PTextField;
        case DynamicFormFieldInputTypeResourceViewModel.TimeInput:
          return PTimeField;
        case DynamicFormFieldInputTypeResourceViewModel.Paragraph:
          return 'p';
        case DynamicFormFieldInputTypeResourceViewModel.Heading:
          return 'h3';
        case DynamicFormFieldInputTypeResourceViewModel.Group:
          return this.isAccordion(fieldDef) ? PAccordion : PFieldset;
        default:
          throw new Error(`Unknown form field type ${fieldDef.inputType}`);
        }
      },
      getIsValid() {
        let isValid = true;
        this.fieldDefinitions.forEach((field) => {
          const { id } = field;
          const { isRequired } = field;
          const value = this.userValues[id];
          if (isRequired && (_.isEmpty(value))) {
            isValid = false;
          }
        });
        return isValid;
      },
      // eslint-disable-next-line no-undef
      buildComponentMap(fieldDefinitions: DynamicFormFieldDefinitionResourceViewModel[]) {
        const componentMap = {} as Record<any, any>;
        fieldDefinitions.forEach((fieldDef) => {
          componentMap[fieldDef.id] = this.mapToComponent(fieldDef);
        });
        return componentMap;
      },
      markdownToHtml(text: string | null | undefined) {
        // TODO: Move to formatter (lazy import any libraries)
        if (text == null) {
          return '';
        }
        // Parse and sanitize
        // special ZERO WIDTH unicode characters (for example \uFEFF) might interfere with parsing
        // encode all characters that could break the html
        // eslint-disable-next-line no-misleading-character-class
        const sanitizedText = text.replace(/^[\u200B\u200C\u200D\u200E\u200F\uFEFF]/, '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
        let parsedAsHtml = (marked.parse(sanitizedText, { breaks: true, gfm: true, async: false }) as string)
        if (this.targetBlank) {
          parsedAsHtml = parsedAsHtml.replace(/(<|&lt;)a /g, '<a target="_blank" rel="noopener noreferrer" ');
        }
        return parsedAsHtml;
      },
      getFieldClass(field: DynamicFormFieldDefinitionResourceViewModel) {
        return [
          'p-form-element',
          field.key ? `dynamic-form-element-${field.key.replaceAll(/[^a-zA-Z0-9\-_]/g, '')}` : '',
          this.isAccordion(field) ? 'my-6' : '',
        ];
      },
      getGroupDisplayOverride(field: DynamicFormFieldDefinitionResourceViewModel): IPDynamicFormGroupDisplay | undefined {
        return field.inputType === DynamicFormFieldInputTypeResourceViewModel.Group
          ? this.groupDisplayOverrides?.find((o) => o.key === field.key)
          : undefined;
      },
      isAccordion(field: DynamicFormFieldDefinitionResourceViewModel): boolean {
        return field.inputType === DynamicFormFieldInputTypeResourceViewModel.Group
          && (this.getGroupDisplayOverride(field)?.isAccordion ?? this.groupsAreAccordions);
      },
      getDefaultValue(field: DynamicFormFieldDefinitionResourceViewModel) {
        return this.getGroupDisplayOverride(field)?.isExpanded ?? field.defaultValue ?? undefined;
      },
    },
  });
</script>
